const AlarmList = () => import('Views/alarm/alarm-list');
const AlarmAddEdit = () => import('Views/alarm/alarm-addEdit');
const AlarmDetail = () => import('Views/alarm/alarm-detail');

export default[
  { path: '/alarm-list', component: AlarmList },
  { path: '/alarm-add', component: AlarmAddEdit },
  { path: '/alarm-edit/:id', component: AlarmAddEdit },
  { path: '/alarm-detail/:id', component: AlarmDetail },
];



// WEBPACK FOOTER //
// ./src/router/alarm.js